const SvgProcessKiller = (props) => (
  <svg height="1em" viewBox="0 0 22 24" width="1em" {...props}>
    <path
      d="M11 0C4.925 0 0 4.835 0 10.8c0 3.636 1.87 6.984 4.889 8.964V24h2.444v-3.6h2.445V24h2.444v-3.6h2.445V24h2.444v-4.248C20.13 17.772 22 14.4 22 10.8 22 4.835 17.075 0 11 0zM6.111 10.8c1.35 0 2.445 1.075 2.445 2.4S7.46 15.6 6.11 15.6c-1.35 0-2.444-1.075-2.444-2.4s1.094-2.4 2.444-2.4zm9.778 0c1.35 0 2.444 1.075 2.444 2.4s-1.094 2.4-2.444 2.4c-1.35 0-2.445-1.075-2.445-2.4s1.095-2.4 2.445-2.4zM11 14.4l1.833 3.6H9.167L11 14.4z"
      fill="currentColor"
      fillRule="nonzero"
    />
  </svg>
)

export default SvgProcessKiller
